<template>
  <div class="snapshot__wrap">
    <div class="snapshot">
      <div class="tab">
        <span
            class="tab_title"
            :class="{ active : block==='MainInfo'}"
            @click="selected_block('MainInfo')"
        >
              {{translate('snapshot.info')}}
          </span>
        <span
            class="tab_title"
            :class="{ active : block==='Details'}"
            @click="selected_block('Details')">
            {{translate('snapshot.details')}}
          </span>
        <span
            class="tab_title"
            :class="{ active : block==='Config'}"
            @click="selected_block('Config')">
            {{translate('snapshot.config')}}
          </span>
        <span
            class="tab_title"
            :class="{ active : block==='Modems'}"
            @click="selected_block('Modems')"
        >
            {{translate('snapshot.modems')}}
          </span>

        <span
            class="tab_title"
            :class="{ active : block==='SDInfo'}"
            @click="selected_block('SDInfo')"
        >
            {{translate('snapshot.sd_info')}}
          </span>

        <span
            class="tab_title"
            :class="{ active : block==='Dev'}"
            @click="selected_block('Dev')"
        >
            Dev Sistematics
          </span>
      </div>

      <div class="block">
        <Config
          v-if="block==='Config'"
          :config="config"
        />
        <MainInfo
          v-if="block==='MainInfo'"
          :info="main_info"
          @close_modal="close"
        />
        <Details
            v-if="block==='Details'"
            :info="details"
        />
        <Modems
          v-if="block==='Modems'"
          :modems="modems"
        />
        <SDInfo
          v-if="block==='SDInfo'"
          :sd_info="sd_info"
        />
        <DevSistematics
            v-if="block==='Dev'"
            :dev_info="dev_sistematics"
        />
      </div>
    </div>
    <div class="text-center">
      <button
          class="btn btn-danger btn-fill btn-wd marginButton"
          @click.prevent="close"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </div>
</template>
<script>

import Config from "./Tabs/Config.vue";
import Details from "./Tabs/Details.vue";
import Modems from "./Tabs/Modems.vue";
import MainInfo from "./Tabs/MainInfo.vue";
import SDInfo from "./Tabs/SDInfo.vue";
import DevSistematics from "./Tabs/Dev.vue";


export default {
  name: 'SnapshotsModal',
  props: ['data'],
  components: {
    Config,
    Details,
    Modems,
    MainInfo,
    SDInfo,
    DevSistematics
  },
  data () {
    return {
      snapshot_info: {},
      block: 'MainInfo',
      deleted: ["config", "modems", "id", "user_name", "order_id", "order_client_name", "group_name", "sd_info", "dev_sistematics"],
      added: ["device_fid", "device_name2", "user_name", "order_client_name","order_client_id", "group_name", "group_id", "user_login", "order_name", "order_id", "description", "created_at"]
    }
  },
  computed:{
    main_info(){
      let info = {}
      Object.keys(this.snapshot_info).forEach((key) => {
        if (this.added.includes(key)) info[key] = this.snapshot_info[key]
      })
      return info
    },
    details(){
      let info = {}
      Object.keys(this.snapshot_info).forEach((key) => {
        if (!this.deleted.includes(key)) info[key] = this.snapshot_info[key]
      })
      return info
    },
    config(){
      return JSON.stringify(this.snapshot_info.config)
    },
    modems(){
      return this.snapshot_info.modems
    },
    sd_info(){
      return this.snapshot_info.sd_info
    },
    dev_sistematics(){
      return this.snapshot_info.dev_sistematics
    },
  },
  created() {
    this.init()
    this.get_device_snapshot()
  },

  destroyed() {
    history.pushState(null, null, this.$route.fullPath)
    if (this.$route.query.snapshot_id) {
      let new_window = this.$route.fullPath.replace('?snapshot_id=' + this.$route.query.snapshot_id, '')
      this.$router.push(new_window)
    }
  },
  methods: {
    init(){
      if (!this.$route.query.snapshot_id) {
        this.old_url = this.$route.fullPath
        history.pushState(null, null, window.location.href + '?snapshot_id=' + this.data.id)
      }
    },
    selected_block(block){
      this.block = block
    },
    get_device_snapshot() {
      this.$http.v1.getDeviceSnapshot( this.data.id, (response) => {
        this.snapshot_info = response.data
      })
    },
     close () {
       this.$emit('close')
    },
  }
}

</script>

<style lang='scss'>
.snapshot{
  height: 100%;
  &__wrap{
    height: 100%;
    padding: 10px;
  }
  .tab{
    width: 100%;
    height: 30px;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: row;
    &_title{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      padding: 5px 0;
      cursor: pointer;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      background-color: #efe9e9;
      border: 1px solid #efe9e9;
      text-wrap: nowrap;
      &.active{
        background-color: white;
        border-bottom: 1px solid white;
      }
    }
  }
  .block{
    height: 95%;
    border: 1px solid #efe9e9;
    margin-top: -1px;
    padding: 10px;
    overflow: auto;
    &::-webkit-scrollbar{
      width: 10px;
    }
  }
}

</style>
